export const getProductInPackGroup = (group, product) => {
    let flavorProduct;
    let selectedProduct;
    let selectedPackage;
    for (let i = 0; i < group.ProductsNew.length; i++) {
        let currentProduct = group.ProductsNew[i];
        if(currentProduct.UnpackagedItem && currentProduct.UnpackagedItem.ID === product.ProductID) {
            flavorProduct = currentProduct.UnpackagedItem;
            selectedProduct = currentProduct;
            break;
        } else {
            currentProduct.Packaging.forEach((packageItem) => {
                packageItem.Flavors.forEach((flavor) => {
                    if(!flavorProduct && flavor.ID === product.ProductID) {
                        flavorProduct = flavor;
                        selectedProduct = currentProduct;
                        selectedPackage = packageItem;
                    }
                });
            });
        }
    }
    return { selectedProduct, flavorProduct, selectedPackage };
};

export const firstAvailableProductInGroup = (group, outOfStockProductIds) => {
    let flavorProduct;
    let selectedProduct;
    let selectedPackage;
    let selectedGroup;
    for (let i = 0; i < group.ProductsNew.length; i++) {
        let currentProduct = group.ProductsNew[i];
        if(!flavorProduct && currentProduct.UnpackagedItem && !outOfStockProductIds.includes(currentProduct.UnpackagedItem.ID)) {
            flavorProduct = currentProduct.UnpackagedItem;
            selectedProduct = currentProduct;
            selectedGroup = group;
            break;
        } else {
            currentProduct.Packaging.forEach((packageItem) => {
                packageItem.Flavors.forEach((flavor) => {
                    if(!flavorProduct && !outOfStockProductIds.includes(flavor.ID)) {
                        flavorProduct = flavor;
                        selectedProduct = currentProduct;
                        selectedPackage = packageItem;
                        selectedGroup = group;
                    }
                });
            });
        }
    }
    return { selectedProduct, flavorProduct, selectedPackage, selectedGroup };
};

export const firstAvailableFlavorInGroup = (group, selectedFlavor, outOfStockProductIds) => {
    let flavorProduct;
    let selectedProduct;
    let selectedPackage;
    let selectedGroup;
    // if flavor is unpackaged item
    let unpackagedFlavor = group.ProductsNew.find(x => x.UnpackagedItem && x.UnpackagedItem.ID === selectedFlavor.ID);
    if(unpackagedFlavor) {
        // return first available product, whether it's packaged or not
        return firstAvailableProductInGroup(group, outOfStockProductIds);
    }
    // else, it's a packaged flavor
    for (let i = 0; i < group.ProductsNew.length; i++) {
        let currentProduct = group.ProductsNew[i];
        if(currentProduct.Packaging) {
            currentProduct.Packaging.forEach((packageItem) => {
                let flavorFound = packageItem.Flavors.find(x => x.ID === selectedFlavor.ID);
                if(flavorFound && packageItem.Flavors.length > 1) {
                    packageItem.Flavors.forEach((flavor) => {
                        if(!flavorProduct && flavor.ID !== selectedFlavor.ID && !outOfStockProductIds.includes(flavor.ID)) {
                            flavorProduct = flavor;
                            selectedProduct = currentProduct;
                            selectedPackage = packageItem;
                            selectedGroup = group;
                        }
                    });
                }
            });
        }
    }
    if(!flavorProduct) {
        return firstAvailableProductInGroup(group, outOfStockProductIds);
    }
    return { selectedProduct, flavorProduct, selectedPackage, selectedGroup };
};

export const getSingleProductsInPackGroups = (packGroups, outOfStockProductIds) => {
    let singleProductsInGroup = [];
    packGroups.forEach((group) => {
        if(group && group.ProductsNew && group.ProductsNew.length === 1) {
            const firstProduct = group.ProductsNew[0];
            if(firstProduct.UnpackagedItem) {
                singleProductsInGroup.push({
                    ProductId: firstProduct.UnpackagedItem.ID,
                    GroupId: group.GroupID,
                    MaxQuantity: group.MaxQuantity,
                    IsOOS: outOfStockProductIds.includes(firstProduct.UnpackagedItem.ID)
                });
            } else if(firstProduct.Packaging &&
                firstProduct.Packaging.length === 1 &&
                firstProduct.Packaging[0].Flavors.length === 1) {
                const firstFlavor = firstProduct.Packaging[0].Flavors[0];
                singleProductsInGroup.push({
                    ProductId: firstFlavor.ID,
                    GroupId: group.GroupID,
                    MaxQuantity: group.MaxQuantity,
                    IsOOS: outOfStockProductIds.includes(firstFlavor.ID)
                });
            }
        }
    });
    return singleProductsInGroup;
};

export const processDefaultPack = (defaultPack, packGroups, outOfStockProductIds) => {
    let resultArray = [];

    defaultPack.forEach((defaultItem) => {
        const matchingGroup = packGroups.find((group) => group.GroupID === defaultItem.GroupID);

        if(matchingGroup) {
            if(defaultItem.Products.length === 0) {
                // get first available product
                let { selectedProduct, flavorProduct } = firstAvailableProductInGroup(matchingGroup, outOfStockProductIds);
                flavorProduct.Quantity = matchingGroup.MaxQuantity;
                resultArray.push({
                    MaxQuantity: matchingGroup.MaxQuantity,
                    GroupName: matchingGroup.GroupName,
                    GroupID: defaultItem.GroupID,
                    ProductID: flavorProduct.ID,
                    MatchingProducts: [{
                        ShortName: selectedProduct.ShortName,
                        ...flavorProduct
                    }],
                    IsIncludedTypeGroup: defaultItem.IsIncludedTypeGroup
                });
            } else {
                defaultItem.Products.forEach((product) => {
                    let { ProductID, Quantity } = product;
                    const productsNewArray = matchingGroup.ProductsNew || [];
                    Quantity = Quantity || 1;
                    const matchingProducts = productsNewArray.reduce((acc, productsNewItem) => {
                        if(productsNewItem.UnpackagedItem) {
                            if(productsNewItem.UnpackagedItem.ID === ProductID) {
                                if(!outOfStockProductIds.includes(productsNewItem.UnpackagedItem.ID)) {
                                    productsNewItem.UnpackagedItem.Quantity = Quantity;
                                    productsNewItem.UnpackagedItem.ShortName = productsNewItem.ShortName;

                                    acc.push({
                                        ...productsNewItem.UnpackagedItem
                                    });
                                } else {
                                    let { selectedProduct, flavorProduct } = firstAvailableFlavorInGroup(matchingGroup, productsNewItem.UnpackagedItem, outOfStockProductIds);
                                    flavorProduct.Quantity = Quantity;
                                    acc.push({
                                        ShortName: selectedProduct.ShortName,
                                        ...flavorProduct
                                    });
                                }
                            }
                        } else {
                            productsNewItem.Packaging.forEach((packageItem) => {
                                packageItem.Flavors.forEach((flavor) => {
                                    if(flavor.ID === ProductID) {
                                        if(!outOfStockProductIds.includes(flavor.ID)) {
                                            flavor.Quantity = Quantity;
                                            acc.push({
                                                PackagingName: packageItem.PackagingName,
                                                ShortName: productsNewItem.ShortName,
                                                ...flavor
                                            });
                                        } else {
                                            let { selectedProduct, flavorProduct, selectedPackage } = firstAvailableFlavorInGroup(matchingGroup, flavor, outOfStockProductIds);
                                            flavorProduct.Quantity = Quantity;
                                            acc.push({
                                                PackagingName: selectedPackage.PackagingName,
                                                ShortName: selectedProduct.ShortName,
                                                ...flavorProduct
                                            });
                                        }
                                    }
                                });
                            });
                        }
                        return acc;
                    }, []);

                    // Check if an entry with the same GroupID already exists in resultArray
                    const existingEntryIndex = resultArray.findIndex(
                        (entry) => entry.GroupID === defaultItem.GroupID
                    );

                    if(existingEntryIndex !== -1) {
                        // Combine the matchingProducts with the existing entry
                        resultArray[existingEntryIndex].MatchingProducts = [
                            ...resultArray[existingEntryIndex].MatchingProducts,
                            ...matchingProducts
                        ];
                    } else {
                        // Add a new entry to resultArray
                        resultArray.push({
                            MaxQuantity: matchingGroup.MaxQuantity,
                            GroupName: matchingGroup.GroupName,
                            GroupID: defaultItem.GroupID,
                            ProductID,
                            MatchingProducts: matchingProducts,
                            IsIncludedTypeGroup: defaultItem.IsIncludedTypeGroup
                        });
                    }
                });
            }
        }
    });

    return resultArray;
};
